import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/navbar.css";
import logo from "../assets/logouni-removebg-preview.png";

export default function Navbar() {
    const [auth, setAuth] = useState("");
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);
    const path = useLocation().pathname;

    useEffect(() => {
        const isAdmin = localStorage.getItem("ADMIN_NGO");
        const isUser = localStorage.getItem("NGO");
        if (isAdmin) {
            setAuth("ADMIN");
        } else if (isUser) {
            setAuth("USER");
        }

        window.scrollTo({ top: 0, behavior: "smooth" });

        const topBar = document.querySelector(".top-bar");
        const navbar = document.querySelector(".navbar");

        function toggleStickyNavbar() {
            if (window.scrollY > topBar.offsetHeight) {
                navbar.classList.add("nav-sticky");
            } else {
                navbar.classList.remove("nav-sticky");
            }
        }
        window.addEventListener("scroll", toggleStickyNavbar);
    }, []);

    // Function to toggle navbar state
    const toggleNavbar = () => {
        setIsNavbarOpen(!isNavbarOpen);
    };

    // Function to close navbar when a link is clicked
    const closeNavbar = () => {
        setIsNavbarOpen(false);
    };

    return (
        <>
            {/* Top Bar (Hidden in Mobile View) */}
            <div className="top-bar d-none d-md-block">
                <div className="container-fluid">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-8">
                            <div className="top-bar-left mt-2">
                                <div className="text contact-info">
                                    <i className="fa fa-phone"></i>
                                    <a href="tel:+919731873276">+91-9731873276</a>
                                    <span className="divider">|</span>
                                    <i className="fa fa-envelope"></i>
                                    <a href="mailto:info@bmb.org.in">info@bmb.org.in</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Navbar */}
            <nav className={`navbar navbar-expand-lg navbar-dark bg-yellow`}>
                <div className="container-fluid">
                    {/* Logo on the left */}
                    <Link to="/" className="navbar-brand">
                        <img src={logo} alt="Logo" className="navbar-logo" />
                    </Link>

                    {/* Burger Menu / Close Icon Toggle */}
                    <button
                        type="button"
                        className="navbar-toggler"
                        onClick={toggleNavbar}
                    >
                        {isNavbarOpen ? (
                            <i className="fa fa-times close-icon"></i> // Close icon when open
                        ) : (
                            <span className="navbar-toggler-icon"></span> // Burger menu when closed
                        )}
                    </button>

                    {/* Navbar Items */}
                    <div className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`} id="navbarCollapse">
                        <div className="navbar-nav ml-auto">
                            <Link to="/" className={`nav-item nav-link ${path === '/' ? "active" : ""}`} onClick={closeNavbar}>Home</Link>
                            <Link to="/about" className={`nav-item nav-link ${path === '/about' ? "active" : ""}`} onClick={closeNavbar}>About</Link>
                            <Link to="/event" className={`nav-item nav-link ${path === '/event' ? "active" : ""}`} onClick={closeNavbar}>Events</Link>
                            <Link to="/famous" className={`nav-item nav-link ${path === '/famous' ? "active" : ""}`} onClick={closeNavbar}>Famous Personality</Link>
                            <Link to="/contact" className={`nav-item nav-link ${path === '/contact' ? "active" : ""}`} onClick={closeNavbar}>Contact</Link>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
}
